import { useCallback } from 'react';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { ProjectConnectionActionType } from '../use-connected-projects/types.tsx';

export const useConnectedProjectsChangeAnalytics = (eventName: string) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		(
			action: ProjectConnectionActionType,
			attributes: { [key: string]: string | number | boolean } = {},
		) => {
			fireUIAnalytics(createAnalyticsEvent({}), `project ${action}`, eventName, attributes);
		},
		[createAnalyticsEvent, eventName],
	);
};
